import React from 'react'
import styled from "styled-components";

function IsOwnerBanner({className}) {
    return (
        <div className="bg-gray100 rounded-16">
            <div className="row flex-column-reverse flex-lg-row align-items-center">

                <div className="col-12 col-lg-6">
                    <Content className="">
                        <h2 className="h1-bold">مالک هستید؟</h2>
                        <p className="h3-normal mt-8">
                            با چند کلیک ساده، ملک‌تون رو به‌صورت رایگان در ۲نبش آگهی و در سریع‌ترین زمان ممکن معامله کنید.
                        </p>

                        <a href="/ثبت/ملک" className="btn btn-primary mt-16 mt-lg-32">
                            ثبت رایگان آگهی
                        </a>
                    </Content>
                </div>

                <div className="col-12 col-lg-6">
                    <KeyImage>
                        <img src="/_img/landings/owner.jpg" className="img-cover" alt="مالک هستید؟"/>
                    </KeyImage>
                </div>
            </div>
        </div>
    )
}

export default React.memo(IsOwnerBanner);

// styles

const KeyImage = styled.div`
    height: 404px;
    
    &, & img {
        border-radius: 16px 0 0 16px;
    }
    
    @media(max-width: ${props => props.theme.screenXsMax}) {
        height: 215px;
        
        &, & img {
            border-radius: 16px 16px 0 0;
        }
    }
`;

const Content = styled.div`
    padding: 0 72px;
    
    @media(max-width: ${props => props.theme.screenXsMax}) {
         padding: 32px 24px 40px;
    }
`;